var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNewsIcon = function SvgNewsIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.63654 2V20.1818C5.6351 20.6636 5.44308 21.1252 5.10242 21.4659C4.76175 21.8065 4.30013 21.9986 3.81836 22H20.182C20.6638 21.9986 21.1254 21.8065 21.4661 21.4659C21.8067 21.1252 21.9987 20.6636 22.0002 20.1818V2H5.63654Z",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27274 13.8182H18.3636",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27274 17.4546H18.3636",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3636 6.54541H9.27274V10.1818H18.3636V6.54541Z",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81818 22C3.33641 21.9986 2.87479 21.8065 2.53412 21.4659C2.19346 21.1252 2.00144 20.6636 2 20.1818V13H5",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNewsIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTUuNjM2NTQgMlYyMC4xODE4QzUuNjM1MSAyMC42NjM2IDUuNDQzMDggMjEuMTI1MiA1LjEwMjQyIDIxLjQ2NTlDNC43NjE3NSAyMS44MDY1IDQuMzAwMTMgMjEuOTk4NiAzLjgxODM2IDIySDIwLjE4MkMyMC42NjM4IDIxLjk5ODYgMjEuMTI1NCAyMS44MDY1IDIxLjQ2NjEgMjEuNDY1OUMyMS44MDY3IDIxLjEyNTIgMjEuOTk4NyAyMC42NjM2IDIyLjAwMDIgMjAuMTgxOFYySDUuNjM2NTRaIgogICAgICAgIHN0cm9rZT0iIzQyMzlGQiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIKICAgICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgogICAgPHBhdGggZD0iTTkuMjcyNzQgMTMuODE4MkgxOC4zNjM2IiBzdHJva2U9IiM0MjM5RkIiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiCiAgICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgogICAgPHBhdGggZD0iTTkuMjcyNzQgMTcuNDU0NkgxOC4zNjM2IiBzdHJva2U9IiM0MjM5RkIiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiCiAgICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgogICAgPHBhdGggZD0iTTE4LjM2MzYgNi41NDU0MUg5LjI3Mjc0VjEwLjE4MThIMTguMzYzNlY2LjU0NTQxWiIgc3Ryb2tlPSIjNDIzOUZCIiBzdHJva2Utd2lkdGg9IjEuNSIKICAgICAgICBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CiAgICA8cGF0aAogICAgICAgIGQ9Ik0zLjgxODE4IDIyQzMuMzM2NDEgMjEuOTk4NiAyLjg3NDc5IDIxLjgwNjUgMi41MzQxMiAyMS40NjU5QzIuMTkzNDYgMjEuMTI1MiAyLjAwMTQ0IDIwLjY2MzYgMiAyMC4xODE4VjEzSDUiCiAgICAgICAgc3Ryb2tlPSIjNDIzOUZCIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIgogICAgICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+Cjwvc3ZnPgogICAg";